// Function to generate random timestamp within last 6 months
const getRandomTimestamp = () => {
  const now = Date.now();
  const sixMonthsAgo = now - (180 * 24 * 60 * 60 * 1000);
  return Math.floor(Math.random() * (now - sixMonthsAgo) + sixMonthsAgo);
};

// Function to generate random price
const getRandomPrice = (min, max) => {
  return (Math.random() * (max - min) + min).toFixed(2);
};

// Generate dummy closed trades data
const generateDummyClosedTrades = (count = 20) => {
  const symbols = ['BTCUSDT', 'ETHUSDT', 'BNBUSDT', 'ADAUSDT', 'SOLUSDT', 'XRPUSDT', 'DOTUSDT', 'DOGEUSDT', 'MATICUSDT', 'LINKUSDT'];
  const sides = ['LONG', 'SHORT', 'BUY', 'SELL'];
  
  return Array.from({ length: count }, (_, idx) => ({
    _id: `trade_${idx + 1}_${Date.now()}`,
    orderId: `ORD${1000000 + idx}`,
    symbol: symbols[Math.floor(Math.random() * symbols.length)],
    pair: symbols[Math.floor(Math.random() * symbols.length)],
    time: getRandomTimestamp().toString(),
    timestamp: getRandomTimestamp().toString(),
    price: getRandomPrice(100, 50000),
    realizedPnl: (Math.random() * 1000 - 500).toFixed(2), // Random profit/loss
    commission: getRandomPrice(0.5, 5),
    pnlPercentage: (Math.random() * 50 - 25).toFixed(2), // -25% to +25%
    qty: Math.floor(Math.random() * 100) + 1,
    quantity: Math.floor(Math.random() * 100) + 1,
    side: sides[Math.floor(Math.random() * sides.length)]
  }));
};

// Generate dummy open/live trades data
const generateDummyLiveTrades = (count = 10) => {
  const symbols = ['BTC/USDT', 'ETH/USDT', 'BNB/USDT', 'ADA/USDT', 'SOL/USDT', 'XRP/USDT'];
  const sides = ['LONG', 'SHORT'];
  
  return Array.from({ length: count }, (_, idx) => ({
    _id: `live_${idx + 1}_${Date.now()}`,
    symbol: symbols[Math.floor(Math.random() * symbols.length)],
    side: sides[Math.floor(Math.random() * sides.length)],
    qty: Math.floor(Math.random() * 50) + 1,
    pnlPercentage: (Math.random() * 30 - 15).toFixed(2), // -15% to +15%
    entryPrice: getRandomPrice(100, 50000),
    currentPrice: getRandomPrice(100, 50000)
  }));
};


// For closed trades:
const dummyClosedTrades = generateDummyClosedTrades(25);

// For live trades:
const dummyLiveTrades = generateDummyLiveTrades(8);


// Export for use in your component
export { generateDummyClosedTrades, generateDummyLiveTrades, dummyClosedTrades, dummyLiveTrades };